import { Link, useParams } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryTabs() {
  const { slug } = useParams<{ slug: string }>();

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2">
      <Link
        to="/category/tutorials"
        className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
          !slug || slug === 'tutorials'
            ? 'bg-primary-500 text-background-50'
            : 'bg-background-100 text-foreground-600 hover:bg-background-200'
        }`}
      >
        全部教程
      </Link>
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
            slug === cat.slug
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200'
          }`}
        >
          {cat.name}
        </Link>
      ))}
    </div>
  );
}